import React, { useState, useEffect } from "react";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { Table, Image, Button } from "react-bootstrap";
import SelectFilter from "../../../reusableComponents/selectFilter";
import { NavLink } from "react-router-dom";
import { useHistory } from "react-router";
import moment from "moment";
import { RightSideCountTop } from "../superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import AddReferreePopup from "../../superAdminAllComponent/superAdminRefferalsCode/referralsPopup/AddReferreePopup";
import { amApi } from "../../../../api/apiHelper";
import { isEmpty } from "lodash";

function DunzoStatement(props) {
  const [dateQuery, setDateQuery] = useState({});
  const [details, setDetails] = useState([]);

  const onDateChangeHandler = () => (data, type) => {
    setDateQuery(data);
  };

  useEffect(() => {
    async function fetchData() {
      let response = await amApi(
        `/dunzoSettlements?statementType=consolidated&from=${dateQuery.startDate}&to=${dateQuery.endDate}`
      );
      setDetails(response.data);
    }
    if (!isEmpty(dateQuery)) {
      fetchData();
    }
  }, [dateQuery]);

  const RenderTableBody = (data, dateQuery) => (
    <TableBody data={data} key={data._id} dateQuery={dateQuery} />
  );

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation displayText="Reports" />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Dunzo statement
                  <br />
                </div>
                <div>
                  <div
                    align="right"
                    style={{ color: "#9E9E9E" }}
                    className="f10-400 my-2"
                  >
                    Report Run Date: {moment().format("LL")}
                  </div>
                  <span
                    className="f12-400 text-grey"
                    style={{ color: "#9E9E9E" }}
                  >
                    Report Range Date:
                  </span>
                  <span className="f12-500">
                    {" "}
                    {moment(dateQuery.startDate).format("LL")} -{" "}
                    {moment(dateQuery.endDate).format("LL")}
                  </span>
                </div>
              </div>
              <div className="row flexcenter">
                <div className="col-4 d-flex"></div>
                <div className="col-5"></div>
                <div className="col-3 d-flex justify-content-end">
                  <div className="mr-3">
                    <SelectFilter onDateChange={onDateChangeHandler()} />
                  </div>
                </div>
              </div>
              <hr />
              <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                {/* <div className="col-12 p-0 user-table-reusable-superadmin table-responsive"> */}
                <Table className="">
                  <thead>
                    <tr className="super_admin_all_users_table_head">
                      <td style={{ width: "20%" }} className="f12-400">
                        From date
                      </td>
                      <td style={{ width: "20%" }} className="f12-400">
                        To date
                      </td>
                      <td style={{ width: "40%" }} className="f12-400">
                        Amount to be Settled
                      </td>
                      <td style={{ width: "40%" }} className="f12-400">
                        Actions
                      </td>
                    </tr>
                  </thead>
                  {details?.map((data) => RenderTableBody(data, dateQuery))}
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const TableBody = ({ data, dateQuery, ...props }) => {
  const [TrDetail, setTrDetail] = useState(false);
  const showTr = () => setTrDetail(!TrDetail);
  const history = useHistory();
  const redirectMerchant = () => {
    history.push(`/superadmin/dunzo/settlements/restaurants`, {
      dateQuery: dateQuery,
      data: data,
    });
  };
  return (
    <tbody
      className="w-100 super-admin-all-vendor-main-table-body"
      key={data._id}
    >
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr className="sd_body_table-row px-0" onClick={showTr}>
                <td style={{ width: "20%" }}>
                  <div>
                    <h5 className="font_16_m ">
                      {moment(dateQuery?.startDate).format("LL")} <br />{" "}
                      {moment(dateQuery?.startDate).format("LT")}
                    </h5>
                  </div>
                </td>
                <td style={{ width: "20%" }}>
                  <h5 className="font_16_m ">
                    {moment(dateQuery?.endDate).format("LL")} <br />{" "}
                    {moment(dateQuery?.endDate).format("LT")}
                  </h5>
                </td>
                <td style={{ width: "40%" }}>
                  <div className="f12-500">
                    ₹ {(data?.amountToSettle || 0).toFixed(2)}
                  </div>
                </td>
                <td style={{ width: "40%" }}>
                  <button
                    onClick={() => redirectMerchant()}
                    className="enViewDashboard btn btn-outline-danger d-flex align-items-center"
                  >
                    view statement
                  </button>
                </td>
              </tr>
              {/* {TrDetail && (
                <>
                  <tr className="sd_accordion_body">
                    <td style={{ width: "18%" }}>
                      <div className="f12-400">Email ID</div>
                      <div className="f12-400">mail@gmail.com</div>
                    </td>
                    <td style={{ width: "15%" }}>
                      <div className="f12-400">Grade / Band</div>
                      <div className="f12-400 mt-2">-</div>
                    </td>
                    <td style={{ width: "15%" }}>
                      <div className="f12-400">City/Location</div>
                      <div className="f12-400 mt-2">pune</div>
                    </td>
                  </tr>
                </>
              )} */}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};

export default DunzoStatement;
